document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[role="tablist"]').forEach((tablist) => {
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    const getPanel = (tab) =>
      document.getElementById(tab.getAttribute("aria-controls"));

    function activateTab(newTab, focusIt = true) {
      tabs.forEach((tab) => {
        const li = tab.closest("li");
        const isActive = tab === newTab;
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.tabIndex = isActive ? 0 : -1;
        if (li) li.classList.toggle("active", isActive);

        const panel = getPanel(tab);
        if (panel) {
          panel.toggleAttribute("hidden", !isActive);
          panel.style.display = isActive ? "block" : "";
          panel.classList.toggle("active", isActive);
          panel.tabIndex = isActive ? 0 : -1;
        }
      });
      if (focusIt) newTab.focus();
    }

    tabs.forEach((tab) => {
      tab.addEventListener("mousedown", (e) => {
        e.preventDefault();
      });

      tab.addEventListener("click", (e) => {
        e.preventDefault();
        activateTab(tab);
      });

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "aria-selected") {
            const currentValue = tab.getAttribute("aria-selected");
            const shouldBeActive = document.activeElement === tab;
            if (shouldBeActive && currentValue === "false") {
              setTimeout(() => {
                tab.setAttribute("aria-selected", "true");
              }, 0);
            }
          }
        });
      });

      observer.observe(tab, {
        attributes: true,
        attributeFilter: ["aria-selected"]
      });
    });

    tablist.addEventListener("keydown", (e) => {
      const current = document.activeElement;
      if (!tabs.includes(current)) return;

      let idx = tabs.indexOf(current);
      let targetIdx = idx;

      switch (e.key) {
        case "ArrowRight":
        case "ArrowDown":
          targetIdx = (idx + 1) % tabs.length;
          e.preventDefault();
          break;
        case "ArrowLeft":
        case "ArrowUp":
          targetIdx = (idx - 1 + tabs.length) % tabs.length;
          e.preventDefault();
          break;
        case "Home":
          targetIdx = 0;
          e.preventDefault();
          break;
        case "End":
          targetIdx = tabs.length - 1;
          e.preventDefault();
          break;
        case "Enter":
        case " ":
          e.preventDefault();
          activateTab(current);
          return;
        default:
          return;
      }
      activateTab(tabs[targetIdx]);
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains("accessibility-contrast")) {
    return;
  }
  const tabs = document.querySelectorAll(".is-nav-tabs");
  tabs.forEach((tab) => {
    tab.addEventListener("focus", () => {
      document.querySelectorAll(".data.item").forEach((item) => {
        item.classList.remove("active");
      });

      document.querySelectorAll(".tab-item").forEach((panel) => {
        panel.classList.remove("active");
        const inner = panel.querySelector(".tab-panel");
        if (inner) inner.style.display = "none";
      });

      const parent = tab.closest(".data.item");
      if (parent) {
        parent.classList.add("active");
      }

      const blockId = tab.getAttribute("data-block-id");
      const targetPanel = document.getElementById(blockId);
      if (targetPanel) {
        targetPanel.classList.add("active");

        const inner = targetPanel.querySelector(".tab-panel");
        if (inner) inner.style.display = "block";
      }
    });
  });
});
